<template>
    <transition name="fade">
        <div class="col-sm-12 nopads">
            <team-item
                    v-for="team in results"
                    v-bind:key="team.id"
                    :team="team"
                    @edit="emitEdit"/>
    </div>
    </transition>
</template>

<script>

    import {timeMixin} from "../../mixins/TimeMixin";
    import {userHelper} from "../../mixins/UserMixin";
    import TeamItem from "./TeamItem";

    export default {
        name: 'team-list',
        components: {TeamItem},
        mixins: [timeMixin, userHelper],
        props: {
            results: {
                type: Array,
                default() {
                    return []
                }
            }
        },
        data() {
            return {
                editMode: false,
            }
        },
        methods: {
            emitEdit: function (item) {
                this.$emit('edit', item)
            }
        }
    }
</script>
